import React, { useEffect, useState } from "react";
import { SectionWrapper } from "../../hoc";
import TableOfContents from "../TableOfContents/TableOfContents.tsx";
import TocMobile from "../ToCTelephone/TocTelephone.tsx";
// import the corresponding css file
import "./Acknowledgement.css";
// import the separated file related to the component
import Texttemplate from "./TextAcknowledgement";
// import the image you want for the top of the page
import { RingLoader } from "react-spinners";
import { scrollToId } from "../../utils/scrollToId";

const Remerciments = ({ setDisplayNavBar }) => {
  const [loading, setLoading] = useState(true);
  // headingData is used in the TableOfContents
  // every title (h2, h3, etc) used in the separated file of the component should be in the table
  const headingsData = [
    {
      // the level 2 is the most important level you can have (the basic one)
      level: 2,
      // the text will be displayed in the table of contents
      text: "Introduction",
      // the id should be the same as the one used in the separated file of the component else the name of the title would not be displayed as wanted
      // do not use space for the id
      id: "introack",
    },
    {
      // the level 2 is the most important level you can have (the basic one)
      level: 2,
      // the text will be displayed in the table of contents
      text: "Sponsors",
      // the id should be the same as the one used in the separated file of the component else the name of the title would not be displayed as wanted
      // do not use space for the id
      id: "Sponsors",
    },
    {
      level: 2,
      text: "Patreons",
      id: "Patreons",
    },
  ];
  // when the page is loaded from the navbar, it sets the position of the user at the top of the page
  useEffect(() => {
    // Simulate a delay (remove this in your actual implementation)
    setTimeout(() => {
      setLoading(false); // Set loading to false after a delay
    }, 2000); // Simulated delay of 2 seconds

    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    setDisplayNavBar(!loading);
    if(!loading){
      scrollToId()
    }
  }, [loading, setDisplayNavBar]);

  return (
    <>
      {/* Display the content of the page on the entire viewport */}
      <div className="relative">
        {loading ? (<div className="spinner-container fixed h-screen w-screen bg-white z-10">
          <RingLoader color="#BA55D3" loading={loading} />{" "}
          <script>{document.body.style.overflow = 'hidden'}</script>
        </div>): <script>{document.body.style.overflow = 'auto'}</script>}
          <>
            {/* Set the size and crop the image on top of the page */}
            <div className="top-page">
              {/* image of your choice will be displayed. Don't forget to change the alt name so it fits with the image */}
              {/* Big title in white that is positioned on the image (no need to change the position, it is already set) */}
              <h1>Acknowledgments</h1>
            </div>
            {/* divide the section in columns */}
            <div
              className="grid grid-cols-12 gap-4"
              style={{ marginRight: "50px", marginLeft: "50px" }}
            >
              {/* section on the left (=Table of content) */}
              <div className="hidden md:block col-span-4 ml-6 order-2 md:order-1">
                {/* it will stay visible on the viewport */}
                <div className="sticky top-4">
                  {/* call the Table of contents with headingData modified above */}
                  <TableOfContents headings={headingsData} />
                </div>
              </div>
              {/* main content which is a separated file you call and it is displayed on the right of the section above */}
              <main className="prose col-span-12 md:col-span-8 order-1 md:order-2">
                <Texttemplate />
              </main>
              {/* display the table of content when the viewport is too small */}
              <div
                className="md:hidden col-span-12 order-3 z-[8]"
                style={{
                  position: "fixed",
                  right: 0,
                  left: 0,
                  bottom: 0,
                  width: "100%",
                  marginRight: "200px",
                  marginLeft: 0,
                  background: "rgba(255, 255, 255, 1)",
                  outline: "2px solid var(--purple-dark)",
                }}
              >
                <TocMobile headings={headingsData} />
              </div>
            </div>
        </>
      </div>
    </>
  );
};

// don't forget to change the name of the component you're exporting
export default SectionWrapper(Remerciments, "remerciments");